import { print } from 'graphql';

import createOneHomeTaskMutation from '~/shared/graphql-queries/home-tasks/create-one-home-task-mutation';
import findHomeTaskWorkspaceLessonQuery from '~/shared/graphql-queries/home-tasks/find-home-task-workspace-lesson-query';
import findUnfinishedHomeTaskLessonsQuery from '~/shared/graphql-queries/home-tasks/find-unfinished-home-task-lessons-query';
import removeByIdHomeTaskMutation from '~/shared/graphql-queries/home-tasks/remove-by-id-home-task-mutation';
import reviewHomeTaskMutation from '~/shared/graphql-queries/home-tasks/review-home-task-mutation';
import updateByIdHomeTaskMutation from '~/shared/graphql-queries/home-tasks/update-by-id-home-task-mutation';
import updateHomeTaskFileStatusMutation from '~/shared/graphql-queries/home-tasks/update-home-task-file-status-mutation';
import updateLessonHomeTaskMutation from '~/shared/graphql-queries/home-tasks/update-lesson-home-task-mutation';
import type { BuilderType } from '~/types';

type CreateOneHomeTaskArgs = Readonly<{
  course?: string;
  courseCategory?: string;
  notes?: string;
  title?: string;
  files?: unknown[];
}>;

type UpdateByIdHomeTaskArgs = Readonly<{ _id?: string; record?: Record<string, unknown> }>;
type RemoveByIdHomeTaskArgs = Readonly<{ _id?: string }>;
type WorkspaceLessonArgs = Readonly<{ _id?: string }>;
type FileStatusArgs = Readonly<{ lessonId: string; fileId: string; status: string }>;
type ReviewArgs = Readonly<{ lessonId: string; status: string }>;
type UpdateLessonHomeTaskArgs = Readonly<{ lessonId: string; homeTaskId: string; status: string }>;
type UnfinishedArgs = Readonly<{ course: string; courseCategory: string; student?: string | null }>;

export const homeTasksTagTypes = [] as const;

export const getHomeTasksQuery = (builder: BuilderType) => ({
  createOneHomeTask: builder.mutation<unknown, CreateOneHomeTaskArgs>({
    query: (args) => ({
      url: '',
      method: 'POST',
      body: JSON.stringify({
        query: print(createOneHomeTaskMutation),
        variables: {
          course: args?.course,
          courseCategory: args?.courseCategory,
          notes: args?.notes,
          title: args?.title,
          files: args?.files,
        },
      }),
    }),
  }),
  updateByIdHomeTask: builder.mutation<unknown, UpdateByIdHomeTaskArgs>({
    query: (args) => ({
      url: '',
      method: 'POST',
      body: JSON.stringify({
        query: print(updateByIdHomeTaskMutation),
        variables: { _id: args?._id, record: args?.record },
      }),
    }),
  }),
  removeByIdHomeTask: builder.mutation<unknown, RemoveByIdHomeTaskArgs>({
    query: (args) => ({
      url: '',
      method: 'POST',
      body: JSON.stringify({
        query: print(removeByIdHomeTaskMutation),
        variables: { _id: args?._id },
      }),
    }),
  }),
  findHomeTaskWorkspaceLesson: builder.query<unknown, WorkspaceLessonArgs>({
    query: (args) => ({
      url: '',
      method: 'POST',
      body: JSON.stringify({
        query: print(findHomeTaskWorkspaceLessonQuery),
        variables: { _id: args?._id },
      }),
    }),
  }),
  updateHomeTaskFileStatus: builder.mutation<unknown, FileStatusArgs>({
    query: (args) => ({
      url: '',
      method: 'POST',
      body: JSON.stringify({
        query: print(updateHomeTaskFileStatusMutation),
        variables: args,
      }),
    }),
  }),
  updateLessonHomeTask: builder.mutation<unknown, UpdateLessonHomeTaskArgs>({
    query: (args) => ({
      url: '',
      method: 'POST',
      body: JSON.stringify({
        query: print(updateLessonHomeTaskMutation),
        variables: args,
      }),
    }),
  }),
  reviewHomeTask: builder.mutation<unknown, ReviewArgs>({
    query: (args) => ({
      url: '',
      method: 'POST',
      body: JSON.stringify({
        query: print(reviewHomeTaskMutation),
        variables: args,
      }),
    }),
  }),
  findUnfinishedHomeTaskLessons: builder.query<unknown, UnfinishedArgs>({
    query: (args) => ({
      url: '',
      method: 'POST',
      body: JSON.stringify({
        query: print(findUnfinishedHomeTaskLessonsQuery),
        variables: args,
      }),
    }),
  }),
});
